import React from 'react';
import { textCodes, titleCodes } from '../../template_codes/29/contact_page_codes';

export default function ContactPage() {
    return (
        <div className="bg-white">
            <div className="mx-auto grid grid-cols-1 items-center pt-8 gap-x-8 px-4 lg:max-w-7xl xl:max-w-7xl 2xl:max-w-7xl lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 lg:px-8  xl:px-8 2xl:px-8">
                <div>
                    <h2 className="text-4xl font-bold tracking-tight text-gray-900">{titleCodes.jewellery.title}</h2>
                    <p className="mt-4 text-gray-500">{textCodes.description.text}</p>

                    <dl className="my-10 grid grid-cols-1 gap-x-6 gap-y-4 lg:gap-x-8">
                        <h2 className="font-bold text-xl">{titleCodes.shop1.title}</h2>
                        <p className="text-gray-500">{textCodes.shop1Ph.text}</p>
                        <p className="text-gray-500">{textCodes.shop1Addr.text}</p>
                        <hr></hr>

                        <h2 className="font-bold text-xl">{titleCodes.shop2.title}</h2>
                        <p className="text-gray-500">{textCodes.shop2Ph.text}</p>
                        <p className="text-gray-500">{textCodes.shop2Addr.text}</p>
                        <hr></hr>

                        <h2 className="font-bold text-xl">{titleCodes.shop3.title}</h2>
                        <p className="text-gray-500">{textCodes.shop3Ph.text}</p>
                        <p className="text-gray-500">{textCodes.shop3Addr.text}</p>
                        <hr></hr>
                    </dl>
                </div>
            </div>
        </div>
    )
}
